/** sessionStorage: simulación activa en este tab */
export const GEO_SIM_SESSION_KEY = "admin_geo_sim_session";

/** sessionStorage: operador ya verificado como elegible (chip visible sin re-auth) */
export const GEO_SIM_ELIGIBLE_KEY = "admin_geo_sim_eligible";

/** Query params del transporte al edge */
export const GEO_SIM_PARAM = "geo_sim";
export const GEO_SIM_TOKEN_PARAM = "gst";

export const GEO_SIM_MINT_PATH = "/api/admin/geo-sim-token";
export const GEO_SIM_MINT_PATH_LEGACY = "/api/admin/geo-simulate";

export type GeoSimVpnMode = "clean" | "anonymous" | "hosting";

export interface GeoSimSession {
  country: string;
  state?: string;
  province?: string;
  city?: string;
  /** Barrio exacto (cta-por-region neighborhood_ar). Solo AR. */
  neighborhood?: string;
  token: string;
  simulateVpn: GeoSimVpnMode;
  /** Optional real IP for privacy lookup (VPN modes only on edge). */
  simulateIp?: string;
  expiresAt?: string;
  path?: string;
}

export const GEO_SIM_QUICK_COUNTRIES: {
  code: string;
  label: string;
  flag: string;
}[] = [
  { code: "AR", label: "Argentina", flag: "🇦🇷" },
  { code: "US", label: "United States", flag: "🇺🇸" },
  { code: "MX", label: "México", flag: "🇲🇽" },
  { code: "ES", label: "España", flag: "🇪🇸" },
  { code: "DE", label: "Deutschland", flag: "🇩🇪" },
  { code: "BR", label: "Brasil", flag: "🇧🇷" },
  { code: "CL", label: "Chile", flag: "🇨🇱" },
  { code: "CO", label: "Colombia", flag: "🇨🇴" },
  { code: "PE", label: "Perú", flag: "🇵🇪" },
  { code: "GB", label: "United Kingdom", flag: "🇬🇧" },
  { code: "FR", label: "France", flag: "🇫🇷" },
  { code: "IT", label: "Italia", flag: "🇮🇹" },
  { code: "CA", label: "Canada", flag: "🇨🇦" },
  { code: "AU", label: "Australia", flag: "🇦🇺" },
];

export const GEO_SIM_US_STATES: { code: string; label: string }[] = [
  { code: "CA", label: "California" },
  { code: "NY", label: "New York" },
  { code: "FL", label: "Florida" },
  { code: "TX", label: "Texas" },
  { code: "IL", label: "Illinois" },
  { code: "WA", label: "Washington" },
];

/**
 * @deprecated Prefer GEO_SIM_AR_PROVINCES_FULL from arLocations (todas las provincias
 * de /admin/cta-por-region). Se mantiene por imports legacy.
 */
export const GEO_SIM_AR_PROVINCES: string[] = [
  "CABA",
  "Buenos Aires",
  "Córdoba",
  "Santa Fe",
  "Mendoza",
  "Tucumán",
  "Entre Ríos",
  "Salta",
  "Neuquén",
  "Río Negro",
  "Misiones",
  "Chaco",
  "Corrientes",
  "Santiago del Estero",
  "San Juan",
  "Jujuy",
  "Formosa",
  "Chubut",
  "San Luis",
  "Catamarca",
  "La Rioja",
  "Santa Cruz",
  "La Pampa",
  "Tierra del Fuego",
];
